import React from 'react';
import { ClassroomProvider } from '@teetsh/app/src/containers/CahierJournal/DayColumn/ClassroomContext';
import { Lines } from './Lines';
import tw from 'twin.macro';
import { Classroom } from '@teetsh/app/src/types/classroom';
import { ClassroomsOrg } from '@teetsh/app/src/types/school';
import { CJEvent } from '@teetsh/app/src/types/event';
import { ClassroomWithGroupeEvent } from '@teetsh/app/src/types/cj';

interface Props {
  classrooms: Classroom[];
  classroom: ClassroomWithGroupeEvent & {
    eventsToDisplay: CJEvent[][][];
  };
  classroomsOrg: ClassroomsOrg;
  collapsed: boolean;
  expanded?: boolean;
  globalScroll?: boolean;
}

export function ClassroomColumn(props: Props) {
  const {
    globalScroll,
    classrooms,
    classroom,
    classroomsOrg,
    collapsed,
    expanded,
  } = props;

  return (
    <div
      data-testid={`seance classroom ${classroom.name}`}
      key={classroom.id}
      css={[
        tw`relative max-h-full flex-grow flex-1 min-h-[50px]`,
        expanded && tw`min-w-[100px]`,
        !expanded && tw`min-w-0`,
      ]}
    >
      <div tw="flex flex-col max-h-full">
        <ClassroomProvider classroom={classroom}>
          {classrooms.length > 1 && (
            <div tw="bg-brand-moderate p-1 mb-2 rounded-lg">
              <h4 tw="shrink-0 mb-4 text-center truncate">{classroom.name}</h4>
            </div>
          )}
          <div
            css={[
              !globalScroll && tw`overflow-y-auto min-h-0`,
              tw`flex-auto overflow-x-auto min-w-0`,
              globalScroll && tw`overflow-y-hidden`,
            ]}
          >
            {classroom.eventsToDisplay.map((listOfEvents, i) => (
              <Lines
                key={i}
                collapsed={collapsed}
                classroomsOrg={classroomsOrg}
                listOfEvents={listOfEvents}
              />
            ))}
          </div>
        </ClassroomProvider>
      </div>
    </div>
  );
}
